module.exports = __webpack_public_path__ + "static/img/GV.06dec64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/other/GV/GV.png
// module id = sfvP
// module chunks = 0